import { resolveAnewApiBase } from '@aba/api-core';

export async function lookupWorldIdentity(hint = {}, options = {}) {
  const email = String(hint.email || '').trim();
  const uid = String(hint.aclUid || hint.slug || '').trim();
  if (!email && !uid) throw new Error('account lookup needs email or account code');
  const request = options.fetchImpl || fetch;
  const baseUrl = resolveAnewApiBase({ baseUrl: options.baseUrl });
  const res = await request(`${baseUrl}/abaham/resolve`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email: email || undefined, uid: uid || undefined })
  });
  const data = await res.json().catch(() => null);
  const wake = data && data.wakeEnvelope;
  if (!res.ok || data?.success !== true || !wake?.hamUid) {
    const err = new Error('account not found');
    err.detail = data || {};
    throw err;
  }
  return {
    acl_uid: String(wake.hamUid),
    display_name: String(wake.displayName || '').trim() || null,
    email_primary: email || null,
    _confidence: wake.confidence,
    _resolvedFrom: wake.method
  };
}
